import Main from './components/Main';

function App() {
  return (
    <div className='App min-h-screen'>
      <Main />
    </div>
  );
}

export default App;
